import { logError } from '@lib/logger';
import { BigBashEvent, Game } from '@/types/types';

export function broadcastJeopardyToRoom(
    screenContent: string,
    extra: Record<string, any>,
    event: BigBashEvent,
    game: Game,
    host: string,
    isHttps: boolean
): void {
    try {
        const protocol = isHttps ? 'wss' : 'ws';
        const ws = new WebSocket(`${protocol}://${host}/ws/room/brain/`);
        ws.addEventListener('open', () => {
            const payload = { screenContent, event, game, ...extra };
            ws.send(JSON.stringify(payload));
            ws.close();
        });
    } catch (err) {
        logError('Failed to send jeopardy broadcast to brain room', err);
    }
}

export async function resetJeopardyGame(
    event: BigBashEvent,
    game: Game,
    deleteGamePointsForGame: (eventId: string, gameId: string) => Promise<void>,
    getEventById: (eventId: string) => Promise<BigBashEvent>,
    broadcast: (screenContent: string, extra: Record<string, any>) => void
): Promise<BigBashEvent> {
    await deleteGamePointsForGame(event.id, game.id);
    const updatedEvent = await getEventById(event.id);
    broadcast('jeopardy-grid', {});
    return updatedEvent;
}
